import React from 'react';

import { MessageTypeEnum } from 'app/shared/enums';
import { InsurersListControlProps } from './InsurersListControl.interfaces';
import {
  SelectControl,
  SelectWithFilterControl,
} from 'app/components/Controls';
import { useListControl } from 'app/shared/hooks/controls/useListControl';
import { Alert } from 'app/components/Alert';
import { useStyles } from './InsurersListControl.styles';

export default function InsurersListControl(props: InsurersListControlProps) {
  const classes = useStyles();

  const { input } = props;

  const { isMobile, handleClick } = useListControl(props);

  const InsurersListControlComponent: React.ElementType = isMobile
    ? SelectControl
    : SelectWithFilterControl;

  return (
    <>
      <InsurersListControlComponent
        {...props}
        onClick={handleClick}
        native={isMobile}
      />
      {input.value && (
        <Alert
          type={MessageTypeEnum.Warning}
          text={
            <>
              <strong>{input.value}</strong>
              <div className={classes.infoBoxEmail}>email</div>
              adres
            </>
          }
          className={classes.infoBox}
        />
      )}
    </>
  );
}
